import {FontAsset} from "@nolimitcity/slot-launcher/bin/loader/font/FontCache";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class AlarmClockFont {
    public static readonly FAMILY: string = "AlarmClock";
    private static readonly BASE_URL: string = "/resources/fonts/";

    public static REGULAR: FontAsset = {
        family: AlarmClockFont.FAMILY,
        weight: FontWeight.BOLD,
        style: FontStyle.NORMAL,
        url: AlarmClockFont.BASE_URL + "AlarmClock.ttf"
    }
}